<template>
  <v-container>
    <div v-html="content">
    </div>
    <v-row class="justify-center">
      <v-checkbox v-model="agreeCheck">
        <template v-slot:label>
          <b style="font-size: 20px;color: red">本人已詳閱且同意上述須知規定</b>
        </template>
      </v-checkbox>
    </v-row>
    <v-divider class="mt-5 mb-1"></v-divider>

    <p class="text-center text-h4">
      停放區域
    </p>
    <v-row class="justify-sm-center">
      <v-col
        v-for="item in spaceList"
        :key="item.ParkingReservedSpace_ID"
        cols="12"
        md="3"
      >
        <v-card
          min-height="340"
          outlined
        >
          <v-card-title>
            <v-row justify="center">
              <v-btn
                color="primary"
                @click="goReserved(item.ParkingReservedSpace_ID)"
              >
                前往登記
              </v-btn>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-subtitle>
            <p class="text-h4 font-weight-bold">
              {{ item.ParkingReservedSpace_Name }}
            </p>
          </v-card-subtitle>
          <v-card-subtitle>
            <p class="text-h6"><strong>連絡電話</strong>: {{ item.ParkingReservedSpace_Tel }}</p>
            <p class="text-h6"><strong>地址</strong>: <a @click="remindDialog=true">{{ item.ParkingReservedSpace_Address }}</a></p>
          </v-card-subtitle>

        </v-card>
      </v-col>
    </v-row>

    <v-divider class="mt-5 mb-5"></v-divider>

    <v-row
      class="mb-7"
      justify="center"
    >
      <v-col
        cols="12"
        md="6"
      >
        <v-card>
          <v-card-title>
            <h4>登記記錄</h4>
          </v-card-title>

          <v-card-subtitle>
            忘了哪時候登記了嗎? 請前往查詢過往登記資料。
          </v-card-subtitle>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="primary"
              :to="`/orderrecord/${siteID}`"
            >
              前往
              <v-icon
                dark
                right
              >mdi-chevron-right-circle</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="remindDialog"
      max-width="700px"
    >
      <v-card>
        <v-card-text>
          <p class="text-center text-h4">
            場地位置圖
          </p>
          <v-img
            v-if="siteInfo.ParkingReserved_SiteInfoCode"
            :src="require(`@/assets/map_${siteInfo.ParkingReserved_SiteInfoCode}.jpg`)"
          ></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="remindDialog = false"
          >
            關閉
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="pauseDialog"
      transition="dialog-bottom-transition"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>系統提示</v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <v-card-text>
          <div class="mt-5">
            <p style="font-size: 20px; color:red;">『系統登記整理中，將在零晨00:00恢復使用。』</p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
export default {
  name: 'ReservedIndex',
  data: () => ({
    siteInfo: {},
    spaceList: [],
    remindDialog: false,
    content: null,
    siteID: null,
    pauseDialog: false,
    agreeCheck: false
  }),
  computed: {},
  created() {
 
  
    this.dbio('/ParkingOnlyReserved/GetReservedSpace', {
      LinkID: this.$route.params.id
    }).then((response) => {
      if (!response || !response.ParkingReserved) {
      this.msg('查無指定場地或該場地已撤場，請聯絡客服', 2000);
      this.$router.replace('/');
      return; 
    }
      this.siteID = this.$route.params.id;
      this.siteInfo = response.ParkingReserved;
      this.content = this.siteInfo.ParkingReserved_Content;
      this.spaceList = response.List_ParkingReservedLeft;
      this.pauseDialog = response.Pause;
     
    });
  
  },
  methods: {
    goReserved(ID) {
      if (this.agreeCheck) {
        this.$router.push('/reservedlist/' + ID);
      } else {
        this.msg('請先勾選同意', 2000);
      }
    }
  }
};
</script>
